import { sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useApplePay } from '../../business/processors/recurly/ApplePayService';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { getString } from '../../constants/Strings';
import { useAppSelector } from '../../hooks/useAppSelector';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
import { ApplePayButton, ApplePayButtonContainer } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
export var RecurlyApplePay = function RecurlyApplePay() {
  var config = useAppSelector(configSelector);
  var appConstants = config.appConstants,
    supportedPaymentMethods = config.supportedPaymentMethods,
    rioNamespace = config.rioNamespace;
  var applePayButtonId = useApplePay();
  var dispatch = useDispatch();
  var applePayJSVersion = appConstants.applePayJSVersion;
  useEffect(function () {
    if (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    !window.ApplePaySession ||
    // @ts-ignore
    !window.ApplePaySession.canMakePayments() ||
    // @ts-ignore
    !window.ApplePaySession.supportsVersion(applePayJSVersion)) {
      dispatch(saveConfigs({
        applepayVisible: false,
        supportedPaymentMethods: supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.filter(function (method) {
          return method !== PaymentMethods.APPLEPAY;
        })
      }));
    } else {
      // RIO Logging: Apple Pay button display successfully
      sendRioEvent({
        info: getString('APP.RIO.EVENTS.EL_NAME.APPLEPAY_LOADED'),
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: sendRioEventCallback,
        namespace: rioNamespace,
        force: false
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(ApplePayButtonContainer, null, /*#__PURE__*/React.createElement(ApplePayButton, {
    style: {
      cursor: 'pointer'
    },
    id: applePayButtonId,
    "aria-label": getString('APP.APPLEPAY.START_BUTTON.ARIA_LABEL'),
    "data-test": DataTestAttributes.RECURLY_APPLEPAY_BUTTON
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/ApplePay/RecurlyApplePay.js
// module id = 4629
// module chunks = 11